<template>
  <a :href="href" class="ticket-validation-icon" @click="onClick">
    <div
      class="icon-plane"
      v-bind:class="{
        invalid: isExpired() && !isValid() && !isPending(),
        pending: isPending() && !isValid(),
        valid: isValid(),
      }"
    >
      <app-plane-navbar-icon />
    </div>
    <span class="ticket-status" v-if="isValid()">{{
      "ticket.status.valid" | trans
    }}</span>
    <span
      class="ticket-status"
      v-else-if="isExpired() && !isValid() && !isPending()"
    >
      {{ "ticket.status.expired" | trans }}
    </span>
    <span class="ticket-status" v-else-if="isPending() && !isValid()">
      {{ "ticket.status.pending" | trans }}
    </span>
    <span class="ticket-status" v-else>{{
      "ticket.status.validate_ticket" | trans
    }}</span>
  </a>
</template>

<script>
import AppPlaneNavbarIcon from "@/components/ui/Icons/PlaneNavbarIcon";
import { mapGetters } from "vuex";

export default {
  name: "AppTicketValidationIcon",
  components: {
    AppPlaneNavbarIcon,
  },
  props: {
    href: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters("customers", ["customer"]),
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
    isValid() {
      let isValid = false;

      if (this.customer) {
        isValid = this.customer.hasValidTicket;
      }

      return isValid;
    },
    isPending() {
      let isPending = false;

      if (this.customer) {
        isPending = this.customer.hasPendingTicket;
      }

      return isPending;
    },
    isExpired() {
      let isExpired = false;

      if (this.customer) {
        isExpired = this.customer.hasExpiredTicket;
      }

      return isExpired;
    },
  },
};
</script>
